import React from "react";

const BillingPaymentIcon = ({
  width = "28",
  height = "29",
  active = false,
  activeColor = "#1D5AB9",
  inActiveColor = "#969998",
  color = active ? activeColor : inActiveColor,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M17.4993 2.74938C16.714 2.17631 15.6483 2.17631 14.863 2.74938L5.37955 9.66976C4.13106 10.5808 4.77548 12.5572 6.32105 12.5572H6.59782V19.9681C5.46006 20.5498 4.68115 21.7334 4.68115 23.0988V25.0155C4.68115 25.5447 5.11022 25.9738 5.63949 25.9738H26.7228C27.2521 25.9738 27.6812 25.5447 27.6812 25.0155V23.0988C27.6812 21.7334 26.9022 20.5498 25.7645 19.9681V12.5572H26.0413C27.5869 12.5572 28.2312 10.5808 26.9827 9.66976L17.4993 2.74938ZM15.9928 4.29764C16.105 4.21577 16.2573 4.21577 16.3695 4.29764L25.0616 10.6405H7.30074L15.9928 4.29764ZM23.8478 12.5572V19.5849H21.2923V12.5572H23.8478ZM19.3756 12.5572V19.5849H17.1395V12.5572H19.3756ZM15.2228 12.5572V19.5849H12.9867V12.5572H15.2228ZM8.19504 21.5016H24.1673C25.0494 21.5016 25.7645 22.2168 25.7645 23.0988V24.0572H6.59782V23.0988C6.59782 22.2168 7.31291 21.5016 8.19504 21.5016ZM8.51449 19.5849V12.5572H11.07V19.5849H8.51449Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default BillingPaymentIcon;
